export const FORM_SUBMIT_DEFAULT_ERROR =
  'An error occurred while submitting the form. Please try again.';
